export const routeMap = {
  LEVEL_UP: {
    path: '/levelup',
    name: '进阶课程',
    NORMAL_MODE: {
      path: '/levelup/normal-mode',
      name: '普通模式',
    },
    LEVEL_MODE: {
      path: '/levelup/levelup-mode',
      name: '通关模式',
    },
    LEVEL_INSTRUCTION: {
      path: '/levelup/level-instruction',
      name: '进阶说明',
    },
    LEVEL_CONRIG: {
      path: '/levelup/level-config',
      name: '进阶关卡配置',
    },
    PASS_STATUS: {
      path: '/levelup/pass-status',
      name: '员工通关情况',
    },
  },
}
